function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M12 6a2 2 0 002-2 1.69 1.69 0 00-.3-1L12 0l-1.7 3a1.69 1.69 0 00-.3 1 2 2 0 002 2zm4.6 10l-1.1-1.1-1 1.1a3.57 3.57 0 01-4.9 0l-1.1-1.1L7.4 16A3.49 3.49 0 015 17a3.61 3.61 0 01-2-.6V21a1.08 1.08 0 001 1h16a1.08 1.08 0 001-1v-4.6a3.38 3.38 0 01-2 .6 3.5 3.5 0 01-2.4-1zM18 9h-5V7h-2v2H6a3 3 0 00-3 3v1.5a2 2 0 002 2 2 2 0 001.4-.6l2.1-2.1 2.1 2.1a2.13 2.13 0 002.8 0l2.1-2.1 2.1 2.1a2 2 0 001.4.6 2 2 0 002-2V12a3 3 0 00-3-3z"
  }));
};
const SvgCake = styled(BaseComponent).withConfig({
  displayName: "Cake__SvgCake",
  componentId: "sc-1a937zy-0"
})(["outline:none;"]);
SvgCake.isIcon = true;
SvgCake.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgCake;